<template>
  <section v-if="cartItems.length" class="section section-aside">
    <div class="section-aside__container" data-sticky>
      <div class="section-aside__cont">
        <a class="icon-link icon-link--base" data-fancybox-full href="#popup-confirm-cart-clean"><span>{{ clearTitle }}</span>
          <svg class="icon-link__icon" aria-hidden="true">
            <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-clear"></use>
          </svg>
        </a>
        <div class="cart-list">
          <div v-for="(items, group) in groupedItems" :key="group" class="cart-list__item">
            <div class="cart-list__item-top">
              <div class="cart-list__item-label">{{ group }}</div>
              <div class="cart-list__item-value">{{ items.length }} {{ numWords(items.length, [declension1, declension2, declension3]) }}</div>
            </div>
            <div class="cart-list__list">
              <div class="cart-list__el" v-for="item in items" :key="item.id">
                <div class="cart-list__el-cont">
                  <div class="cart-list__el-img">
                    <picture v-if="item.img">
                      <img :src="item.img" alt="alt" loading="lazy">
                    </picture>

                    <img v-else src="/local/templates/xpage/img/catalog/product.svg" alt="Заглушка товара" loading="lazy">
                  </div>
                  <div class="cart-list__el-desc">
                    <a v-if="item.link === ''" class="cart-list__el-name">{{ item.name }}</a>
                    <a v-else class="cart-list__el-name" :href="item.link">{{ item.name }}</a>
                    <div v-if="item.constructorName" class="cart-list__el-info">{{ item.constructorName }}</div>
                    <div class="cart-list__el-info">{{ item.info }}</div>
                  </div>
                </div>

                <div class="cart-list__el-confirm" v-if="isDelete[item.id]">
                  <p class="cart-list__el-label">{{ clearConfirm }}</p>
                  <div class="cart-list__el-btns">
                    <button class="icon-link icon-link--base" @click="removeFromCartNext(item.id)">
                      <span>{{ cartDelete }}</span>
                      <svg class="icon-link__icon" aria-hidden="true">
                        <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-close"></use>
                      </svg>
                    </button>
                    <button class="icon-link icon-link--base" @click="removeFromCartPrev(item.id, false)">
                      <span>{{ cartReturn }}</span>
                      <svg class="icon-link__icon" aria-hidden="true">
                        <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-return"></use>
                      </svg>
                    </button>
                  </div>
                </div>
                <add-to-cart-basket
                    v-else
                    :product-id='Number(item.productId)'
                    :cur-quantity='Number(item.quantity)'
                    :min-quantity='Number(item.quantityMin)'
                    :max-quantity='Number(item.quantityMax)'
                    :step-quantity=5
                ></add-to-cart-basket>
                <button v-if="!isDelete[item.id]" class="cart-list__el-del" @click="removeFromCartPrev(item.id, true)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-aside__aside section-aside__aside--sticky sticky-el">
        <div class="order-card">
          <div class="order-card__order">
            <div class="order-card__order-label">{{ cartTitle }}</div>
            <div class="order-card__order-value">{{ cartItems.length }} {{ numWords(cartItems.length, [declension1, declension2, declension3]) }}</div>
          </div>
          <div class="order-card__top">
            <div class="order-card__subtitle">{{ cartText }}</div>
          </div>
          <div class="order-card__bottom">
            <div class="order-card__btns">
              <a class="default-btn default-btn--green" :href="siteDir + 'checkout'">
                {{ cartToCheckout }}
                <svg class="default-btn__icon" aria-hidden="true">
                  <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section v-show="this.isEmpty" class="section section-cart">
    <div class="section-cart__container">
      <div class="section-cart__empty">
        <div class="section-cart__empty-cont">
          <div class="section-cart__empty-title">{{ cartEmpty }}</div>
          <div class="section-cart__empty-links">
            <a class="icon-link icon-link--base" :href="siteDir + 'catalog/stock/'">
              {{ cartToStock }}
              <svg class="icon-link__icon" aria-hidden="true">
                <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
              </svg>
            </a>
            <a class="icon-link icon-link--base" :href="siteDir + 'catalog/'">
              {{ cartToCatalog }}
              <svg class="icon-link__icon" aria-hidden="true">
                <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
              </svg>
            </a>
            <a class="icon-link icon-link--base" :href="siteDir + 'catalog/individual-packing/'">
              {{ cartToIndividual }}
              <svg class="icon-link__icon" aria-hidden="true">
                <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
              </svg>
            </a>
          </div>
          <div class="section-cart__empty-btns">
            <a class="default-btn default-btn--green" :href="siteDir">
              {{ cartToMainPage }}
              <svg class="default-btn__icon" aria-hidden="true">
                <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="popup popup--confirm" id="popup-confirm-cart-clean">
    <div class="popup__container">
      <div class="popup__title">{{ clearConfirmAll }}</div>
      <div class="popup__btns">
        <a class="default-btn default-btn--green" href="javascript:;" @click="cartClean()">
          {{ popupClear }}
          <svg class="default-btn__icon" aria-hidden="true">
            <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-clear"></use>
          </svg>
        </a>
        <a class="default-btn default-btn--dark" href="javascript:;" @click="closeFancybox()">{{ popupCancel }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import AddToCartBasket from "@/components/cart/AddToCartBasket.vue";

export default {
  name: "CartBig",
  props: {
    clearTitle: {
      type: [String],
      default: BX.message('CART_CLEAR')
    },
    declension1: {
      type: [String],
      default: BX.message('CART_DECLENSION_1')
    },
    declension2: {
      type: [String],
      default: BX.message('CART_DECLENSION_2')
    },
    declension3: {
      type: [String],
      default: BX.message('CART_DECLENSION_3')
    },
    clearConfirm: {
      type: [String],
      default: BX.message('CART_CLEAR_CONFIRM')
    },
    cartDelete: {
      type: [String],
      default: BX.message('CART_DELETE')
    },
    cartReturn: {
      type: [String],
      default: BX.message('CART_RETURN')
    },
    cartTitle: {
      type: [String],
      default: BX.message('CART_TITLE')
    },
    cartText: {
      type: [String],
      default: BX.message('CART_TEXT')
    },
    cartToCheckout: {
      type: [String],
      default: BX.message('CART_TO_CHECKOUT')
    },
    cartEmpty: {
      type: [String],
      default: BX.message('CART_EMPTY')
    },
    cartToStock: {
      type: [String],
      default: BX.message('CART_TO_STOCK')
    },
    cartToCatalog: {
      type: [String],
      default: BX.message('CART_TO_CATALOG')
    },
    cartToIndividual: {
      type: [String],
      default: BX.message('CART_TO_INDIVIDUAL')
    },
    cartToMainPage: {
      type: [String],
      default: BX.message('CART_TO_MAIN_PAGE')
    },
    clearConfirmAll: {
      type: [String],
      default: BX.message('CART_CLEAR_CONFIRM_ALL')
    },
    popupClear: {
      type: [String],
      default: BX.message('CART_POPUP_CLEAR')
    },
    popupCancel: {
      type: [String],
      default: BX.message('CART_POPUP_CANCEL')
    },
    siteDir: {
      type: [String],
      default: '/'
    },
  },
  data() {
    return {
      isDelete: [],
      isEmpty: false,
    };
  },
  components: {
    AddToCartBasket
  },
  computed: {
    ...mapGetters('moduleCart', {
      cartItems: 'allItems',
      productInCart: 'productInCart',
    }),
    groupedItems: function(){
      let map = this.cartItems.reduce((r, i) => {
        r[i.group] = r[i.group] || [];
        r[i.group].push(i);
        return r;
      }, {});
      return map;
    }
  },
  watch: {
    cartItems() {
      setTimeout(() => {
        this.isEmpty = this.cartItems.length < 1;
      }, 200);
    },
  },
  methods: {
    ...mapActions('moduleCart', {
      removeFromCart: 'remove',
      setQuantity: 'quantity',
    }),
    numWords(value, words){
      value = Math.abs(value) % 100;
      var num = value % 10;
      if(value > 10 && value < 20) return words[2];
      if(num > 1 && num < 5) return words[1];
      if(num == 1) return words[0];
      return words[2];
    },
    cartClean(){
      this.cartItems.forEach(item => {
        this.removeFromCart(item.id);
      });

      this.isEmpty = true;
      this.closeFancybox();
    },
    closeFancybox(){
      window.FancyBox.close();
    },
    removeFromCartPrev(productId, view){
      this.isDelete[productId] = view;
    },
    removeFromCartNext(productId){
      this.removeFromCart(productId);
      setTimeout(() => {
        if (!this.productInCart(productId)) {
          this.isDelete[productId] = false;
        }

        this.isEmpty = this.cartItems.length < 1;
      }, 300);
    },
  },
}
</script>